import { Radio, RadioGroup } from '@base-ui/react';
import { useId } from 'react';

import type { SearchInvestmentType } from './searchPagination';

const INVESTMENT_TYPE_CHOICES = [
  {
    value: '',
    label: 'All',
  },
  { value: 'equity', label: 'Equities' },
  { value: 'etf', label: 'ETFs' },
  { value: 'mutual_fund', label: 'Mutual Funds' },
] as const;

type InvestmentTypeFilterProps = {
  value: SearchInvestmentType;
  onChange: (value: SearchInvestmentType) => void;
};

export function InvestmentTypeFilter({
  value,
  onChange,
}: InvestmentTypeFilterProps) {
  const id = useId();

  function handleChange(nextValue: string) {
    onChange(
      nextValue === 'equity' ||
        nextValue === 'etf' ||
        nextValue === 'mutual_fund'
        ? nextValue
        : undefined,
    );
  }

  return (
    <>
      <div className="sr-only" id={id}>
        Investment Type:
      </div>

      <RadioGroup
        aria-labelledby={id}
        value={value ?? ''}
        onValueChange={handleChange}
        className="flow-24 lg:flow-12 flex gap-4"
      >
        {INVESTMENT_TYPE_CHOICES.map(({ value: choiceValue, label }) => {
          return (
            <Radio.Root
              value={choiceValue}
              className="group/radio"
              key={choiceValue}
              data-track="search_investment_type"
              data-track-label={label}
              data-track-context="search_filter"
            >
              <label className="group-data-checked/radio:bg-button-primary-bg group-data-checked/radio:text-gray-10 border-button-primary-bg text-blue-70 text-static-16 rounded-full border px-10 py-4 text-center">
                <Radio.Indicator />
                {label}
              </label>
            </Radio.Root>
          );
        })}
      </RadioGroup>
    </>
  );
}
